var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUforum = function SvgUforum(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 19,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M0 0c.94 8.402 3.272 18.967 7.095 19 3.66-.127 6.183-12.12 6.903-16.42-1.689 4.322-4.327 11.304-6.805 11.645C4.408 14.065 1.683 5.77.003 0z",
    clipRule: "evenodd"
  })));
};
export default SvgUforum;